import React, {Component} from 'react';
import PropTypes from 'prop-types';
import {connect} from 'react-redux';
import compose from 'recompose/compose';

import MuiThemeProvider from 'material-ui/styles/MuiThemeProvider';
import getMuiTheme from 'material-ui/styles/getMuiTheme';
import {Card, CardActions} from 'material-ui/Card';
import Avatar from 'material-ui/Avatar';
import RaisedButton from 'material-ui/RaisedButton';
import CircularProgress from 'material-ui/CircularProgress';
import LockIcon from 'material-ui/svg-icons/action/lock-outline';
import {cyan500, pinkA200} from 'material-ui/styles/colors';

import defaultTheme from 'components/defaultTheme';
import Notification from 'components/layout/Notification';

import {userLogin as userLoginAction} from 'actions/authActions';

const styles = {
    main: {
        display: 'flex',
        flexDirection: 'column',
        minHeight: '100vh',
        alignItems: 'center',
        justifyContent: 'center',
    },
    card: {
        minWidth: 300,
    },
    avatar: {
        margin: '1em',
        textAlign: 'center ',
    },
    form: {
        padding: '0 1em 1em 1em',
    },
    input: {
        display: 'flex',
    },
};

function getColorsFromTheme(theme) {
    if (!theme) return {primary1Color: cyan500, accent1Color: pinkA200};
    const {
        palette: {
            primary1Color,
            accent1Color,
        },
    } = theme;
    return {primary1Color, accent1Color};
}

class Login extends Component {

    constructor(props) {
        super(props);
        this.signIn = this.signIn.bind(this);
    }

    signIn(e) {
        if (e) {
            e.preventDefault(); // to prevent submit if used within form
        }

        const {redirectUri, fetchBasicProfile, prompt, scope, responseType, userLogin, location} = this.props;
        const options = {
            response_type: responseType,
            redirect_uri: redirectUri,
            fetch_basic_profile: fetchBasicProfile,
            prompt,
            scope,
        };

        userLogin(options, location.state ? location.state.nextPathname : '/');
    }

    render() {
        const {submitting, theme} = this.props;
        const muiTheme = getMuiTheme(theme);
        const {primary1Color, accent1Color} = getColorsFromTheme(muiTheme);
        return (
            <MuiThemeProvider muiTheme={muiTheme}>
                <div style={{...styles.main, backgroundColor: primary1Color}}>
                    <Card style={styles.card}>
                        <div style={styles.avatar}>
                            <Avatar backgroundColor={accent1Color} icon={<LockIcon />} size={60}/>
                        </div>
                        <CardActions>
                            <RaisedButton
                                primary
                                disabled={submitting}
                                icon={submitting && <CircularProgress size={25} thickness={2}/>}
                                label={('Sign In with Google')}
                                onTouchTap={this.signIn}
                                fullWidth
                            />
                        </CardActions>
                    </Card>
                    <Notification />
                </div>
            </MuiThemeProvider>
        );
    }
}

Login.propTypes = {
    authClient: PropTypes.func,
    previousRoute: PropTypes.string,
    theme: PropTypes.object.isRequired,
    submitting: PropTypes.bool.isRequired,
    userLogin: PropTypes.func.isRequired,
    clientId: PropTypes.string.isRequired,
    onRequest: PropTypes.func,
    scope: PropTypes.string,
    cookiePolicy: PropTypes.string,
    hostedDomain: PropTypes.string,
    children: PropTypes.node,
    style: PropTypes.object,
    disabledStyle: PropTypes.object,
    fetchBasicProfile: PropTypes.bool,
    prompt: PropTypes.string,
    tag: PropTypes.string,
    autoLoad: PropTypes.bool,
    disabled: PropTypes.bool,
    discoveryDocs: PropTypes.array,
    responseType: PropTypes.string,
    uxMode: PropTypes.string,
};

Login.defaultProps = {
    theme: defaultTheme,
    scope: 'profile email',
    responseType: 'permission',
    prompt: '',
    fetchBasicProfile: true,
    disabledStyle: {
        opacity: 0.6,
    },
    clientId: '622450700549-cj8j49v78bhnij9vvp9ni9j8o3g1m49l.apps.googleusercontent.com',
};

function mapStateToProps(state, props) {
    return {
        submitting: state.admin.loading > 0,
    }
}

const enhance = compose(
    connect(mapStateToProps, {userLogin: userLoginAction}),
);

export default enhance(Login);



// WEBPACK FOOTER //
// ./src/routes/auth/Login.js